// Server Functions
import axios from 'axios';
import * as libCon from '../Constants.js';

export const getUpdatedWearableCoverage = async (email) => {
  let emailString = `${email}`.replace('@gmail.com', '');
  let link = `${libCon.WEARABLE_COVERAGE_URL}/${emailString}`;

  try {
    const response = await axios.get(link);

    if (response.status === 200) {
      let data = response.data.data;

      let internalId = Object.keys(data)[0];

      data[internalId] = { ...data[internalId], [libCon.ID]: internalId, [libCon.KEY]: internalId };

      return [libCon.OK, data];
    } else return [libCon.ERROR, null];
  } catch (error) {
    console.log(error);
    if (error.message === 'Network request failed') return [libCon.NETWORK_ERROR, null];

    return [libCon.ERROR, null];
  }
};

export const decryptPdf = async (pdfBytes) => {
  // Convert pdfBytes into a Blob
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

  // Prepare form data
  const formData = new FormData();
  formData.append('pdf', pdfBlob, 'encrypted.pdf');

  // Send request
  const response = await fetch(libCon.DECRYPT_PDF_URL, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Failed to decrypt PDF: ${response.statusText}`);
  }

  // Get decrypted PDF back as Uint8Array
  const decryptedArrayBuffer = await response.arrayBuffer();
  return new Uint8Array(decryptedArrayBuffer);
};
